import InfoIcon from 'Components/Icons/InfoIcon';
import { TOKEN, clearCaseDraftApi, getCasesApi, getCaseDraftApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ClientCaseListRender from './ClientCaseListRender';
import CreationLimitModal from 'Modals/CreationLimitModal';
import FindAttorney from './FindAttorney';
import ClientStatistics from './ClientStatistics';
import { CiViewList } from "react-icons/ci";

import RequestPreview from './RequestPreview';
import { IoCreate, IoCreateOutline } from 'react-icons/io5';

function ClientCaseList() {
    const {userDetails, makeApiCallFunc} = useContext(Context)
    const [updateCaseList, setUpdateCaseList] = useState(false);
    const [caseLimitReached, setCaseLimitReached] = useState(false);
    const [responseReceived, setResponseReceived] = useState(false);
    const scrollToRef = useRef(null);
    const {_id} = userDetails;
    const [caseList, setCaseList] = useState(null);
    const navigate = useNavigate();
    const [showLimitModal, setShowLimitModal] = useState(false);
    // A client gets exactly one in-progress case draft, autosaved as they
    // move through the create-case wizard (CreateFormLanding.jsx). Surface
    // it here so they can pick up where they left off instead of starting
    // over - "+ Create new case" already auto-resumes it too, but a lot of
    // people won't discover that without seeing it called out.
    const [draft, setDraft] = useState(null);

    useEffect(()=>
    {
          makeApiCallFunc(
            getCasesApi+'/'+_id,
            null,
            ({data})=>
            {
                window.scrollTo(0,0);
                setCaseList(data);
                setCaseLimitReached(data?.length > 2);
                setResponseReceived(true);
            },
            function (error) {
                console.log(error);
            }
          )
          
    }, [updateCaseList]);

    useEffect(() => {
        makeApiCallFunc(
            getCaseDraftApi,
            null,
            ({ data }) => {
                setDraft(data && data.formValues && Object.keys(data.formValues).length ? data : null);
            },
            () => {},
            false,
            true
        );
    }, [updateCaseList]);

    const discardDraft = () => {
        makeApiCallFunc(clearCaseDraftApi, { clear: true }, () => setDraft(null), null, false, true);
    };
    const createCaseOnclick = () => {
    
        if(!responseReceived)
        {
            return;
        }
        if(caseLimitReached)
        {
            setShowLimitModal(true);
        } 
        else
        {
           navigate("/client/createCase");
        }
    }
  return (
    <>
        {
            showLimitModal &&
            <CreationLimitModal
            uploadNew={showLimitModal}
            onClose={() => setShowLimitModal(false)}
            />
        }
        
            <div className='flex flex-col w-full font-plexsans bg-cream'>
                        <RequestPreview/>
                        <div className='flex flex-col w-full px-4 pt-6 pb-4 lg:px-8 lg:pt-8 lg:pb-6'>
                            <div className='flex justify-between items-baseline mb-4 lg:mb-5 flex-col lg:flex-row gap-3 lg:gap-0'>
                                <h1 className="font-spectral font-normal text-[22px] leading-[1.25] text-navy text-center lg:text-left w-full lg:w-auto">
                                    Your cases
                                </h1>
                                <button
                                onClick={createCaseOnclick}
                                className={(!responseReceived ? "pointer-events-none opacity-50 " : "") + " whitespace-nowrap flex-none rounded-sm cursor-pointer transition-colors w-full lg:w-auto font-plexsans font-medium text-[12.5px] leading-none text-ivory bg-brass border-0 py-3 px-5 hover:bg-brassDark"}
                                >
                                    + Create new case
                                </button>
                            </div>
                            {draft && (
                                <div className="w-full flex items-center justify-between gap-4 rounded-lg px-5 py-4 mb-4 lg:mb-5 flex-col lg:flex-row bg-gold/[.12] border border-gold/[.35]">
                                    <div>
                                        <div className='font-plexsans font-semibold text-[14px] leading-[1.3] text-navy'>You have an unfinished case</div>
                                        <div className="font-plexsans font-normal text-[12.5px] leading-[1.4] text-navy/[.55] mt-0.5">Pick up where you left off, or discard it and start fresh.</div>
                                    </div>
                                    <div className="flex items-center gap-4 flex-none">
                                        <button
                                        onClick={discardDraft}
                                        className="cursor-pointer bg-transparent border-none font-plexsans font-medium text-[12.5px] leading-none text-navy/[.5]"
                                        >
                                            Discard
                                        </button>
                                        <button
                                        onClick={() => navigate("/client/createCase")}
                                        className="whitespace-nowrap rounded-sm cursor-pointer transition-colors font-plexsans font-semibold text-[12.5px] leading-none text-ivory bg-brass border-0 py-[11px] px-[18px] hover:bg-brassDark"
                                        >
                                            Continue draft →
                                        </button>
                                    </div>
                                </div>
                            )}
                            <div className='w-full flex flex-col' ref={scrollToRef}>
                                <FindAttorney 
                                caseList={caseList}
                                setUpdateCaseList={setUpdateCaseList}
                                updateCaseList={updateCaseList}
                                /> 
                                <ClientCaseListRender
                                caseList={caseList}
                                setUpdateCaseList={setUpdateCaseList}
                                updateCaseList={updateCaseList}
                                />
                            </div>
                        </div>
            </div>
    </>    
  )
}

export default ClientCaseList